import { Sun, Moon, Monitor } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';
import { RadioCardGroup } from '../inputs/RadioCardGroup';
import type { RadioCardOption } from '../inputs/RadioCardGroup';

type ThemeOption = 'light' | 'dark' | 'system';

const themeOptions: RadioCardOption<ThemeOption>[] = [
  {
    id: 'light',
    label: 'Light',
    icon: <Sun className="w-5 h-5" />,
    description: 'Always use light mode',
  },
  {
    id: 'dark',
    label: 'Dark',
    icon: <Moon className="w-5 h-5" />,
    description: 'Always use dark mode',
  },
  {
    id: 'system',
    label: 'System',
    icon: <Monitor className="w-5 h-5" />,
    description: 'Match your device settings',
  },
];

export function AppearanceTab() {
  const { theme, setTheme } = useTheme();

  return (
    <div className="max-w-lg">
      <h2 className="text-lg font-semibold text-text-primary mb-1">
        Theme
      </h2>
      <p className="text-sm text-text-secondary mb-6">
        Choose how the app looks to you.
      </p>

      <RadioCardGroup
        options={themeOptions}
        value={theme}
        onChange={setTheme}
        name="Theme selection"
      />
    </div>
  );
}
